var render = function render(){var _vm=this,_c=_vm._self._c;return _c('o-form-group',{attrs:{"label":_vm.label}},[_c('o-datepicker-control',{attrs:{"typeable":_vm.typeable,"readonly":_vm.readonly,"disabled":_vm.disabled,"open-date":_vm.openDate,"disabled-dates":_vm.disabledDates},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }